document.addEventListener('DOMContentLoaded', () => {
    // ==========================================
    // 0. 地図制御クラス (JichicaMap)
    // ==========================================
    class JichicaMap {
        constructor(elementId, options) {
            this.map = new google.maps.Map(document.getElementById(elementId), {
                center: options.center,
                zoom: options.zoom,
                disableDefaultUI: true,
                zoomControl: true,
            });
            this.circleRadius = options.circleRadius || 200;
        }

        addAreaMarker(pos, title, address, customStyles = {}) {
            const marker = new google.maps.Marker({
                position: pos,
                map: this.map,
                title: title,
                icon: customStyles.icon || null
            });

            const circleOptions = customStyles.circle || {
                radius: this.circleRadius,
                fillColor: '#FF0000',
                fillOpacity: 0.08,
                strokeColor: '#FF0000',
                strokeOpacity: 0.15,
                strokeWeight: 1
            };

            const areaCircle = new google.maps.Circle({
                map: this.map,
                center: pos,
                clickable: false,
                ...circleOptions
            });

            return { marker, areaCircle };
        }
    }

    window.JichicaMap = JichicaMap;

    // ==========================================
    // ★追加：Google Maps APIを動的にロードする関数
    // ==========================================
    const loadGoogleMapsScript = (callback) => {
        if (window.google && window.google.maps) {
            callback();
            return;
        }

        if (document.getElementById('google-maps-api-script')) {
            const checkExist = setInterval(() => {
                if (window.google && window.google.maps) {
                    clearInterval(checkExist);
                    callback();
                }
            }, 100);
            return;
        }

        const script = document.createElement('script');
        script.id = 'google-maps-api-script';

        const apiKey = (typeof jichikai_vars !== 'undefined') ? jichikai_vars.google_map_api : "";

        // APIの課金節約のため libraries=places を削除
        script.src = `https://maps.googleapis.com/maps/api/js?key=${apiKey}`;
        script.async = true;
        script.defer = true;
        script.onload = callback;
        document.head.appendChild(script);
    };

    // ==========================================
    // ★ 表記揺れ吸収用の正規化関数
    // ==========================================
    const normalizeString = (str) => {
        if (!str) return "";
        return str
            // 1. 全角英数字を半角に変換
            .replace(/[Ａ-Ｚａ-ｚ０-９]/g, s => String.fromCharCode(s.charCodeAt(0) - 0xFEE0))
            // 2. 「ヶ」「ヵ」「ツ」「つ」などの表記揺れを「ケ」に統一
            .replace(/[ヶヵツつ]/g, 'ケ')
            .replace(/ッ(?=[一-龯々])/g, 'ツ')

            // 3. 比較しやすいように念のため小文字化（アルファベット対応）
            .toLowerCase();
    };

    // ==========================================
    // 1. 共通データ・変数定義
    // ==========================================
    let allJichikaiData = [];

    const AREA_CITY_MAP = {
        yokohama: [
            {key: "tsurumiku", label: "鶴見区"}, {key: "kanagawaku", label: "神奈川区"},
            {key: "nishiku", label: "西区"}, {key: "nakaku", label: "中区"},
            {key: "minamiku", label: "南区"}, {key: "konanku", label: "港南区"},
            {key: "hodogayaku", label: "保土ケ谷区"}, {key: "asahiku", label: "旭区"},
            {key: "isogoku", label: "磯子区"}, {key: "kanazawaku", label: "金沢区"},
            {key: "kouhokuku", label: "港北区"}, {key: "midoriku", label: "緑区"},
            {key: "aobaku", label: "青葉区"}, {key: "tsuzukiku", label: "都筑区"},
            {key: "totsukaku", label: "戸塚区"}, {key: "sakaeku", label: "栄区"},
            {key: "izumiku", label: "泉区"}, {key: "seyaku", label: "瀬谷区"}
        ],
        kawasaki: [
            {key: "kawasakiku", label: "川崎区"}, {key: "saiwaiku", label: "幸区"}, {key: "nakaharaku", label: "中原区"},
            {key: "takatsuku", label: "高津区"}, {key: "miamaeku", label: "宮前区"}, {key: "tamaku", label: "多摩区"},
            {key: "asaoku", label: "麻生区"}
        ],
        miura: [
            {key: "yokosukashi", label: "横須賀市"}, {key: "kamakurashi", label: "鎌倉市"},
            {key: "zushishi", label: "逗子市"}, {key: "miurashi", label: "三浦市"}, {key: "hayamamachi", label: "葉山町"}
        ],
        shonan: [
            {key: "hiratsukashi", label: "平塚市"}, {key: "fujisawashi", label: "藤沢市"},
            {key: "chigasakishi", label: "茅ヶ崎市"}, {key: "hadanoshi", label: "秦野市"},
            {key: "iseharashi", label: "伊勢原市"}, {key: "samukawamachi", label: "寒川町"},
            {key: "oisomachi", label: "大磯町"}, {key: "ninomiyamachi", label: "二宮町"}
        ],
        kenou: [
            {key: "sagamiharashi", label: "相模原市"}, {key: "atsugishi", label: "厚木市"},
            {key: "yamatoshi", label: "大和市"}, {key: "ebinashi", label: "海老名市"},
            {key: "zamashi", label: "座間市"}, {key: "ayaseshi", label: "綾瀬市"},
            {key: "aikawamachi", label: "愛川町"}, {key: "kiyokawamura", label: "清川村"}
        ],
        kensei: [
            {key: "odawarashi", label: "小田原市"}, {key: "minamiashigarashi", label: "南足柄市"},
            {key: "nakaimachi", label: "中井町"}, {key: "ooimachi", label: "大井町"},
            {key: "matsudamachi", label: "松田町"}, {key: "yamakitamachi", label: "山北町"},
            {key: "kaiseimachi", label: "開成町"}, {key: "hakonemachi", label: "箱根町"},
            {key: "manazurumachi", label: "真鶴町"}, {key: "yugawaramachi", label: "湯河原町"}
        ]
    };

    // 市区キーからラベル（「横浜市瀬谷区」「座間市」など）への逆引きマップ生成
    const CITY_KEY_TO_LABEL = {};
    Object.entries(AREA_CITY_MAP).forEach(([areaKey, list]) => {
        list.forEach(city => {
            // yokohamaグループの場合は「横浜市」を先頭に付加
            const prefix = (areaKey === 'yokohama') ? '横浜市' : '';
            CITY_KEY_TO_LABEL[city.key] = prefix + city.label;
        });
    });

    // データから市区名を取得するヘルパー関数
    const getCityLabel = (item) => {
        if (!item) return "";

        // 0. item.city_key から最優先で判定
        if (item.city_key && CITY_KEY_TO_LABEL[item.city_key]) {
            return CITY_KEY_TO_LABEL[item.city_key];
        }

        let label = item.city_label || item.city_name || "";

        // 1. URLのスラッグから判定 (例: /seyaku/ → 横浜市瀬谷区)
        if (!label && item.url) {
            for (const [key, cityLabel] of Object.entries(CITY_KEY_TO_LABEL)) {
                if (item.url.includes(`/${key}/`)) {
                    return cityLabel;
                }
            }
        }

        // 2. 住所から判定
        if (!label && item.address) {
            for (const [key, cityLabel] of Object.entries(CITY_KEY_TO_LABEL)) {
                const rawLabel = cityLabel.replace('横浜市', '');
                if (item.address.includes(cityLabel) || item.address.includes(rawLabel)) {
                    return cityLabel;
                }
            }
        }

        // 横浜市の区（「〜区」で終わり「横浜市」が含まれていない場合）への「横浜市」自動補填
        if (label && label.endsWith('区') && !label.includes('横浜市')) {
            label = '横浜市' + label;
        }

        return label;
    };

    const AREA_LABELS = {
        yokohama: "横浜", kawasaki: "川崎", miura: "横須賀・三浦",
        shonan: "湘南", kenou: "県央", kensei: "県西"
    };

    const CITY_CENTERS = {
        'sakaeku': { lat: 35.361, lng: 139.551 },
        'nakaku': { lat: 35.440, lng: 139.645 },
        'minamiku': { lat: 35.428, lng: 139.610 },
        'nishiku': { lat: 35.453, lng: 139.628 },
        'yokosukashi': { lat: 35.281, lng: 139.672 },
        'zamashi': { lat: 35.488584, lng: 139.407594 },
        'asahiku': { lat: 35.4716, lng: 139.5484 },
        'totsukaku': { lat: 35.400, lng: 139.534 },
        'hodogayaku': { lat: 35.459, lng: 139.596 },
        'midoriku': { lat: 35.513, lng: 139.534 },
        'seyaku': { lat: 35.466, lng: 139.497 },
        'kouhokuku': { lat: 35.541, lng: 139.632 },
    };

    const activeKeys = (typeof jichikai_vars !== 'undefined') ? jichikai_vars.active_keys : [];
    const disabledMapKeys = (typeof jichikai_vars !== 'undefined' && jichikai_vars.disabled_map_keys) ? jichikai_vars.disabled_map_keys : [];

    const ui = {
        modal: document.getElementById('jichikaiSearchModal'),
        content: document.getElementById('jichikaiModalContent'),
        combinedSection: document.getElementById('jichikaiCombinedSection'),
        title: document.getElementById('jichikaiModalTitle'),
        backBtn: document.getElementById('jichikaiBackBtn'),
        closeBtns: [document.getElementById('jichikaiModalClose'), document.getElementById('jichikaiModalOverlay')],
        form: document.getElementById('address-search-form'),
        input: document.getElementById('address-search-input'),
        cityKey: document.getElementById('target-city-key'),
        results: document.getElementById('address-results-container'),
        list: document.getElementById('address-results-list'),
        msg: document.getElementById('address-search-message'),
        loading: document.getElementById('address-loading'),
        closeResults: document.getElementById('close-results-btn'),
        mapContainer: document.getElementById('modal-map-container'),
        mapInstance: null,
        areaElements: []
    };

    const safeSetClick = (id, fn) => {
        const el = document.getElementById(id);
        if (el) el.onclick = fn;
    };

    const closeModal = () => {
        if (ui.modal) ui.modal.style.display = "none";
        document.body.style.overflow = "";
    };

    ui.closeBtns.forEach(btn => btn && (btn.onclick = closeModal));

    // ==========================================
    // UI表示・遷移ロジック
    // ==========================================
    const CITY_PLACEHOLDERS = {
        'sakaeku': '例：飯島町、本郷台',
        'nishiku': '例：桜木町、藤棚',
        'nakaku': '例：元町、山下町',
        'minamiku': '例：弘明寺、井土ケ谷',
        'kanagawaku': '例：反町、東神奈川',
        'tsurumiku': '例：生麦、鶴見中央',
        'asahiku': '例：鶴ヶ峰、白根',
        'totsukaku': '例：戸塚町、品濃町',
        'hodogayaku': '例：星川、天王町',
        'midoriku': '例：中山、長津田',
        'seyaku': '例：瀬谷、三ツ境',
        'zamashi': '例：緑ケ丘、相武台',
        'kouhokuku': '例：大倉山、日吉',
    };

    const showAreaMap = (e) => {
        if (e && typeof e.preventDefault === 'function') e.preventDefault();
        if (!ui.modal) return;

        ui.title.innerHTML = `
            地図から地域を選択してください<br>
            <span style="font-size: 0.9em; font-weight: normal; margin-top: 5px; display: block;">
                現在、<strong>横浜市（旭区、戸塚区除く）、座間市</strong>で検索できます
            </span>
        `;
        ui.backBtn.style.display = "none";
        ui.combinedSection.style.display = "none";
        ui.content.style.display = "block";
        ui.content.innerHTML = "";

        const originalMap = document.querySelector('.search-map-wrap');
        if (originalMap) {
            const clonedMap = originalMap.cloneNode(true);
            clonedMap.style.display = "block";
            ui.content.appendChild(clonedMap);

            const areas = clonedMap.querySelectorAll('.map-area');
            areas.forEach(area => {
                const areaKey = area.getAttribute('data-area');
                const hasActiveCity = AREA_CITY_MAP[areaKey].some(city => activeKeys.includes(city.key));
                if (hasActiveCity) {
                    area.style.cursor = "pointer";
                    area.onclick = () => showCitySelect(areaKey);
                } else {
                    area.style.fill = "#cccccc";
                    area.style.opacity = "0.5";
                    area.style.cursor = "not-allowed";
                }
            });
        }
        ui.modal.style.display = "flex";
        document.body.style.overflow = "hidden";
    };

    const showCitySelect = (areaKey) => {
        ui.title.textContent = `${AREA_LABELS[areaKey]}の市区町村を選択`;
        ui.content.innerHTML = "";
        ui.content.style.display = "grid";
        ui.combinedSection.style.display = "none";
        ui.backBtn.style.display = "block";
        ui.backBtn.onclick = showAreaMap;

        AREA_CITY_MAP[areaKey].forEach(city => {
            const btn = document.createElement("button");
            // const isActive = activeKeys.includes(city.key);
            // const isActive = activeKeys.includes(city.key) && city.key !== 'asahiku';
            // const isActive = activeKeys.includes(city.key) && city.key !== 'asahiku' && city.key !== 'totsukaku';
            const isActive = activeKeys.includes(city.key) && !disabledMapKeys.includes(city.key);
            btn.className = isActive ? "search-btn bold is-active" : "search-btn bold is-disabled";
            btn.textContent = city.label;
            if (isActive) {
                btn.onclick = () => showCombinedSearch(city, areaKey);
            } else {
                btn.disabled = true;
            }
            ui.content.appendChild(btn);
        });
    };

    const showCombinedSearch = (city, areaKey) => {
        ui.title.textContent = `${city.label}内で探す`;
        ui.content.style.display = "none";
        ui.combinedSection.style.display = "flex";
        ui.backBtn.onclick = () => showCitySelect(areaKey);

        ui.cityKey.value = city.key;
        ui.input.value = "";
        ui.results.style.display = "none";

        const placeholderText = CITY_PLACEHOLDERS[city.key] || "例：町名を入力";
        ui.input.placeholder = placeholderText;

        const center = CITY_CENTERS[city.key] || { lat: 35.447, lng: 139.642 };

        loadGoogleMapsScript(() => {
            if (!ui.mapInstance) {
                if (typeof window.JichicaMap === 'function') {
                    ui.mapInstance = new window.JichicaMap("modal-map", {
                        center: center,
                        zoom: 14,
                        circleRadius: 200
                    });
                }
            } else {
                ui.mapInstance.map.setCenter(center);
                ui.mapInstance.map.setZoom(14);
            }

            setTimeout(() => google.maps.event.trigger(ui.mapInstance.map, "resize"), 100);
            loadMarkers(city.key);
        });
    };

    // ==========================================
    // 2. loadMarkers 関数
    // ==========================================
    const loadMarkers = (cityKey) => {
        if (ui.areaElements) {
            ui.areaElements.forEach(el => {
                el.marker.setMap(null);
                el.areaCircle.setMap(null);
            });
        }
        ui.areaElements = [];

        if (ui.mapInstance && ui.mapInstance.map && ui.mapInstance.map.data) {
            ui.mapInstance.map.data.forEach(feature => {
                ui.mapInstance.map.data.remove(feature);
            });
            google.maps.event.clearListeners(ui.mapInstance.map.data, "click");
            google.maps.event.clearListeners(ui.mapInstance.map.data, "mouseover");
            google.maps.event.clearListeners(ui.mapInstance.map.data, "mouseout");
        }

        // ------------------------------------------
        // 【ポリゴンエリア対応市区の描画モード】
        // ------------------------------------------
        // const polygonCities = ['yokosukashi', 'zamashi'];
        const polygonCities = ['zamashi'];

        if (polygonCities.includes(cityKey)) {
            const map = ui.mapInstance.map;

            const host = window.location.host;
            const rootPath = host.includes('local') ? '/jichikai' : '';
            // const jsonUrl = `${window.location.origin}${rootPath}/common-assets/mapdata/map_${cityKey}.json`;
            // const jsonUrl = `${window.location.origin}${rootPath}/common-assets/mapdata/map_${cityKey}.json?v=${Date.now()}`;
            const mapVersion = host.includes('local') ? Date.now() : '1.0.1';
            const jsonUrl = `${window.location.origin}${rootPath}/common-assets/mapdata/map_${cityKey}.json?v=${mapVersion}`;

            const mainColor = "#009bde";

            map.data.loadGeoJson(jsonUrl);

            map.data.setStyle({
                fillColor: mainColor,
                fillOpacity: 0.15,
                strokeColor: mainColor,
                strokeOpacity: 0.8,
                strokeWeight: 1.5,
                clickable: true
            });

            map.data.addListener("mouseover", (event) => {
                map.data.revertStyle();
                map.data.overrideStyle(event.feature, {
                    fillOpacity: 0.35,
                    strokeWeight: 2.5
                });
            });
            map.data.addListener("mouseout", (event) => {
                map.data.revertStyle();
            });

            const dataPath = host.includes('local') ? `/jichikai/${cityKey}/` : `/${cityKey}/`;
            fetch(`${window.location.origin}${dataPath}wp-content/uploads/jichikai_data/${cityKey}.json?v=${Date.now()}`)
                .then(res => res.json())
                .then(data => {
                    allJichikaiData = data;
                })
                .catch(err => console.error("自治会データの取得エラー:", err));

            const normalizeName = (name) => {
                if (!name) return "";
                return name
                    .replace(/[Ａ-Ｚａ-ｚ０-９]/g, (s) => String.fromCharCode(s.charCodeAt(0) - 0xFEE0))
                    .replace(/（単独）/g, "")
                    .replace(/\(単独\)/g, "")
                    .trim();
            };

            const iw = new google.maps.InfoWindow();
            map.data.addListener("click", (event) => {
                const rawJichikaiName = event.feature.getProperty("name") || "名称未設定の自治会";

                const normalizedTargetName = normalizeName(rawJichikaiName);
                const matchedJichikai = allJichikaiData.find(item =>
                    normalizeName(item.title) === normalizedTargetName
                );

                let siteUrl = "";
                if (matchedJichikai && matchedJichikai.url) {
                    siteUrl = matchedJichikai.url;
                } else {
                    const fallbackPath = host.includes('local') ? `/jichikai/${cityKey}/` : `/${cityKey}/`;
                    siteUrl = `${window.location.origin}${fallbackPath}?jcc=${encodeURIComponent(rawJichikaiName)}`;
                }

                let actionHtml = "";
                if (cityKey === 'yokosukashi') {
                    actionHtml = `<p style="margin: 5px 0 0 0; font-size: 11px; color: #d9534f; font-weight: bold;">※自治会サイトは現在準備中です。</p>`;
                } else {
                    actionHtml = `<a href="${siteUrl}" style="display: inline-block; background: ${mainColor}; color: #fff; padding: 6px 12px; border-radius: 4px; text-decoration: none; font-size: 12px; font-weight: bold;">自治会サイトを見る</a>`;
                }

                const popupContent = `
                    <div class="jcc-map-popup" style="padding: 5px; font-family: sans-serif;">
                        <h4 style="margin: 0 0 5px 0; font-size: 14px; color: #333;">${rawJichikaiName}</h4>
                        <p style="margin: 0 0 10px 0; font-size: 11px; color: #666;">こちらのエリアを管轄する自治会です。</p>
                        ${actionHtml}
                    </div>
                `;
                iw.setContent(popupContent);
                iw.setPosition(event.latLng);
                iw.open(map);
            });

            return;
        }

        // ------------------------------------------
        // 【その他の区：通常ピン描画モード】
        // ------------------------------------------
        const host = window.location.host;
        const path = host.includes('local') ? `/jichikai/${cityKey}/` : `/${cityKey}/`;
        fetch(`${window.location.origin}${path}wp-content/uploads/jichikai_data/${cityKey}.json?v=${Date.now()}`)
            .then(res => res.json())
            .then(data => {
                allJichikaiData = data;
                data.forEach(item => {
                    const pos = {lat: parseFloat(item.lat), lng: parseFloat(item.lng)};
                    const areaEl = ui.mapInstance.addAreaMarker(pos, item.title, item.address, {
                        icon: null,
                        circle: {
                            radius: 120,
                            strokeColor: '#1E90FF',
                            strokeOpacity: 0.08,
                            strokeWeight: 1,
                            fillColor: '#1E90FF',
                            fillOpacity: 0.15
                        }
                    });

                    const iw = new google.maps.InfoWindow({
                        content: `<div style="padding:10px;"><h4><a href="${item.url}" target="_blank" rel="noopener">${item.title}</a></h4><p>${item.address}</p><a href="${item.url}" target="_blank" rel="noopener">詳細を見る</a></div>`
                    });
                    areaEl.marker.addListener("click", () => iw.open(ui.mapInstance.map, areaEl.marker));
                    ui.areaElements.push(areaEl);
                });
            });
    };

    // ==========================================
    // ★ 3. 検索ロジック (町名・丁目から探す) 天才ロジック・完全版 v3（漢数字対応）
    // ==========================================
    const performSearch = async (e) => {
        if (e) e.preventDefault();
        const rawQuery = ui.input.value.trim();
        if (!rawQuery) return;

        // 1. 漢数字を半角数字に変換するヘルパー関数（ヤムG特製）
        const convertKanjiToNum = (str) => {
            if (!str) return "";
            const map = { '一': '1', '二': '2', '三': '3', '四': '4', '五': '5', '六': '6', '七': '7', '八': '8', '九': '9' };
            let converted = str;
            for (const [kanji, num] of Object.entries(map)) {
                converted = converted.replace(new RegExp(kanji, 'g'), num);
            }
            // 十の位の簡易変換（例：十→10, 十二→12, 二十→20, 二十一→21）
            converted = converted.replace(/十([1-9])/g, '1$1')
                                 .replace(/([1-9])十([1-9])/g, '$1$2')
                                 .replace(/([1-9])十/g, '$10')
                                 .replace(/^十/, '10');
            return converted;
        };

        // 2. 検索キーワードの正規化（全角英数字→半角、漢数字→半角数字、ヶなどの揺れを吸収）
        const normalizedBase = normalizeString(rawQuery);
        const normQuery = convertKanjiToNum(normalizedBase);

        // 3. 検索クエリから「丁目」の数字を正確に抽出する（半角・全角対応）
        const chomeMatch = normQuery.match(/([0-9０-９]+)\s*丁目/);
        let targetChome = chomeMatch ? chomeMatch[1] : null;

        if (!targetChome) {
            const numMatch = normQuery.match(/([0-9０-９]+)$/);
            targetChome = numMatch ? numMatch[1] : null;
        }

        // 数字や「丁目」を取り除いた「純粋な町名」を抽出
        const queryTownOnly = normQuery.replace(/[0-9０-９]+.*$/, '').replace(/丁目.*$/, '').trim();

        // 数字を半角に統一するヘルパー関数
        const toHalfNum = (str) => {
            if (!str) return "";
            return str.replace(/[０-９]/g, s => String.fromCharCode(s.charCodeAt(0) - 0xFEE0));
        };
        const halfTargetChome = toHalfNum(targetChome);

        const targetKey = ui.cityKey.value;
        if (!targetKey) return;

        ui.loading.style.display = "flex";
        ui.results.style.display = "none";
        ui.msg.innerHTML = "検索中...";

        try {
            const host = window.location.host;
            const path = host.includes('local') ? `/jichikai/${targetKey}/` : `/${targetKey}/`;
            const url = `${window.location.origin}${path}wp-content/uploads/jichikai_data/${targetKey}.json?v=${Date.now()}`;

            const res = await fetch(url);
            if (!res.ok) throw new Error('Network response was not ok');

            // const data = await res.json();
            const rawData = await res.json();
            const data = rawData.map(item => ({ ...item, city_key: targetKey }));

            // ★天才ロジック：ピース単位での厳密な町名・丁目マッチング
            const filtered = data.filter(item => {
                const targetTitle = normalizeString(item.title || "");
                const targetAddress = normalizeString(item.address || "");
                const targetArea = normalizeString(item.area || "");

                // 全テキストをカンマや読点で分割して「ピース（地域断片）」の配列にする
                const combinedStr = `${targetTitle},${targetAddress},${targetArea}`;
                const parts = combinedStr.split(/[、,]/);

                for (let part of parts) {
                    const cleanPart = part.trim();
                    if (!cleanPart) continue;

                    // ① このピースに町名（例：「入谷西」）が含まれているか？
                    if (queryTownOnly && cleanPart.includes(queryTownOnly)) {

                        // ユーザーが「丁目」を指定している場合
                        if (halfTargetChome) {
                            const matchChomePattern = new RegExp(`${halfTargetChome}\\s*丁目`);
                            const matchZenChomePattern = new RegExp(`${targetChome}\\s*丁目`);

                            if (matchChomePattern.test(cleanPart) || matchZenChomePattern.test(cleanPart)) {
                                return true;
                            }

                            // 町名の直後にある数字を検証する（例：「入谷西５丁目」なら「５」）
                            const townIdx = cleanPart.indexOf(queryTownOnly);
                            if (townIdx !== -1) {
                                const afterTown = cleanPart.substring(townIdx + queryTownOnly.length);
                                const leadingNumMatch = afterTown.match(/^([0-9０-９]+)/);
                                if (leadingNumMatch) {
                                    const leadingNum = toHalfNum(leadingNumMatch[1]);
                                    if (leadingNum === halfTargetChome) {
                                        return true;
                                    }
                                } else {
                                    if (cleanPart.includes(halfTargetChome)) {
                                        return true;
                                    }
                                }
                            }
                        } else {
                            // ② 丁目指定がない場合（例：「入谷西」のみで検索）
                            return true;
                        }
                    }
                }

                return false;
            });

            ui.loading.style.display = "none";
            ui.results.style.display = "block";

            if (filtered.length > 0) {
                ui.list.innerHTML = filtered.map(item => {
                    const cityLabel = getCityLabel(item);
                    return `
                        <a href="${item.url}" class="d-block c-inherit s-result-item border bg-wht radius-s padding-box-xs">
                            <div class="s-result-title radius-s bg-maindark c-wht flex flex-wrap flex-al-c flex-jc-sb"><div class="bold">${item.title}</div>
                            ${cityLabel ? `<div class="margin-l-auto tag2 fs-s">${cityLabel}</div>` : ''}
                            </div></div>
                            ${item.area ? `<div class="s-result-addr mgt-05">地域：${item.area}</div>` : ''}
                            <div class="al-r s-result-link btn-text">詳細を見る</div>
                        </a>
                    `;
                }).join('');
                ui.msg.innerHTML = `該当する自治会が <strong>${filtered.length}</strong> 件見つかりました。`;
            } else {
                ui.msg.innerHTML = '該当する自治会が <strong>0</strong> 件見つかりました。';
                ui.list.innerHTML = '<p class="no-results">該当する自治会は見つかりませんでした。</p>';
            }
        } catch (err) {
            console.error("検索エラー:", err);
            ui.loading.style.display = "none";
            ui.msg.innerHTML = "データの取得に失敗しました。";
        }
    };

    // イベント紐付け
    safeSetClick('trigger-address-search', showAreaMap);
    safeSetClick('trigger-map-search', showAreaMap);

    if (ui.form) ui.form.onsubmit = performSearch;

    if (ui.closeResults) {
        ui.closeResults.onclick = () => { ui.results.style.display = "none"; };
    }

    // ==========================================
    // 自治会名から直接探す
    // ==========================================
    const nameSearchForm = document.getElementById('direct-name-search-form');
    const nameInput = document.getElementById('direct-name-input');

    if (nameSearchForm) {
        nameSearchForm.onsubmit = async (e) => {
            e.preventDefault();
            const query = nameInput.value.trim();
            if (!query) return;

            ui.modal.style.display = "flex";
            ui.title.textContent = `「${query}」の検索結果`;
            ui.content.style.display = "none";
            ui.combinedSection.style.display = "flex";
            ui.backBtn.style.display = "none";
            ui.mapContainer.style.display = "none";

            const addrSection = ui.combinedSection.querySelector('.addressSearchSection');
            if (addrSection) addrSection.style.display = "none";
            const closeResultsBtn = document.getElementById('close-results-btn');
            if (closeResultsBtn) closeResultsBtn.style.display = "none";

            ui.loading.style.display = "flex";
            ui.results.style.display = "none";
            ui.msg.innerHTML = "全エリアから検索中...";

            try {
                const host = window.location.host;
                // const fetchPromises = activeKeys.map(key => {
                //     const path = host.includes('local') ? `/jichikai/${key}/` : `/${key}/`;
                //     const url = `${window.location.origin}${path}wp-content/uploads/jichikai_data/${key}.json?v=${Date.now()}`;
                //     return fetch(url).then(res => res.json());
                // });
                const fetchPromises = activeKeys.map(key => {
                    const path = host.includes('local') ? `/jichikai/${key}/` : `/${key}/`;
                    const url = `${window.location.origin}${path}wp-content/uploads/jichikai_data/${key}.json?v=${Date.now()}`;
                    return fetch(url)
                        .then(res => res.json())
                        .then(data => data.map(item => ({ ...item, city_key: key })));
                });

                const allResultsArray = await Promise.all(fetchPromises);
                const flatData = allResultsArray.flat();

                // ここでも表記揺れを少し吸収しておくと親切です
                // let normQuery = query.replace(/[Ａ-Ｚａ-ｚ０-９]/g, s => String.fromCharCode(s.charCodeAt(0) - 0xFEE0));
                const normQuery = normalizeString(query);
                // console.log("【検索キーワード】入力:", query, "→ 正規化後:", normQuery);

                // const filtered = flatData.filter(item => item.title.includes(query) || item.title.includes(normQuery));
                const filtered = flatData.filter(item => {
                    // データに title が無い場合は安全のためスキップ
                    if (!item || !item.title) return false;

                    const normTitle = normalizeString(item.title);

                    return normTitle.includes(normQuery);
                });
                // console.log("【最終ヒット件数】", filtered.length);

                ui.loading.style.display = "none";
                ui.results.style.display = "block";

                if (filtered.length > 0) {
                    ui.list.innerHTML = filtered.map(item => {
                        const cityLabel = getCityLabel(item);
                        return `
                            <a href="${item.url}" class="d-block c-inherit s-result-item border bg-wht radius-s padding-box-xs">
                                <div class="s-result-title radius-s bg-maindark c-wht flex flex-wrap flex-al-c flex-jc-sb"><div class="bold">${item.title}</div>
                                ${cityLabel ? `<div class="margin-l-auto tag2 fs-s">${cityLabel}</div>` : ''}
                                </div></div>
                                ${item.area ? `<div class="s-result-addr mgt-05">地域：${item.area}</div>` : ''}
                                <div class="al-r s-result-link btn-text">詳細を見る</div>
                            </a>
                        `;
                    }).join('');
                    ui.msg.innerHTML = `全エリアから <strong>${filtered.length}</strong> 件見つかりました。`;
                } else {
                    ui.msg.innerHTML = '該当する自治会が <strong>0</strong> 件見つかりました。';
                    ui.list.innerHTML = '<p class="no-results">該当する自治会は見つかりませんでした。</p>';
                }
            } catch (err) {
                console.error("検索エラー:", err);
                ui.loading.style.display = "none";
                ui.msg.innerHTML = "データの取得に失敗しました。";
            }
        };
    }

    // ==========================================
    // UIのリセット処理
    // ==========================================
    const resetSearchUI = () => {
        const addrSection = ui.combinedSection.querySelector('.addressSearchSection');
        if (addrSection) addrSection.style.display = "";
        const closeResultsBtn = document.getElementById('close-results-btn');
        if (closeResultsBtn) closeResultsBtn.style.display = "";

        ui.mapContainer.style.display = "";
        ui.results.style.display = "none";
        ui.input.value = "";
    };

    ui.closeBtns.forEach(btn => {
        if (btn) {
            btn.onclick = () => {
                resetSearchUI();
                closeModal();
            };
        }
    });
});